import { EMPTY_OBJECT } from '../../../../constants/common'
import { useSelection } from '../../../../hooks'
import { useDocFlowSendingContext } from '../useDocFlowSendingContext'
import { useSendingTableActions } from '../useSendingTableActions'

export function useDocFlowSendingCommunicationTable() {
  const { usersTableData } = useDocFlowSendingContext()

  const { items, pagination } = usersTableData || EMPTY_OBJECT

  const selectionData = useSelection({
    data: items,
    pagination,
  })

  const {
    handleToggleSaveToProfile,
    handleToggleSendAdditionalEmail,
    handleToggleSendEmail,
    handleToggleSendEpost,
    setItemAction,
    setMassAction,
  } = useSendingTableActions({
    selectionData,
    usersTableData,
  })

  return {
    handleToggleSaveToProfile,
    handleToggleSendAdditionalEmail,
    handleToggleSendEmail,
    handleToggleSendEpost,
    selectionData,
    setItemAction,
    setMassAction,
    usersTableData,
  }
}
